var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.partner==='UNI')?_c('bank-chooser-uni'):_c('bank-chooser-all')}
var staticRenderFns = []

export { render, staticRenderFns }